import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertCircle, RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-brand-navy flex items-center justify-center p-4">
          <div className="bg-white rounded-[28px] p-8 max-w-md w-full text-center shadow-2xl">
            <AlertCircle className="w-16 h-16 text-brand-coral mx-auto mb-6" />
            <h1 className="font-heading font-black text-2xl mb-4 text-brand-black">
              SOMETHING WENT WRONG
            </h1>
            <p className="text-gray-600 mb-8">
              The application encountered an unexpected error. Don't worry, your plumbing and electrical is still safe!
            </p>
            <Button 
              onClick={() => window.location.reload()}
              className="bg-brand-blue hover:bg-brand-navy text-white rounded-full px-8 py-6 w-full flex items-center justify-center gap-2 font-bold"
            >
              <RefreshCcw className="w-5 h-5" /> Refresh Page
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;